/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 *
 */

import axios from 'axios';
import {isAccessTokenExpired} from '../utils/tokenUtils';
import {SPS_INFO_ACCESS_TOKEN} from "../utils/cookieUtils";
import {STATUS_OK, VSP_LOGIN_URL} from "../utils/constants";

const HOST_API_URL = window.env.TLC_DMZ_GATEWAY_URL;
// gateway routes /oauth/** to TLC authorization service
const BEARER = 'Bearer';
const AUTHORIZATION = 'Authorization';

const axiosWithoutToken = axios.create({
    baseURL: `${HOST_API_URL}`,
});

const axiosWithToken = axios.create({
    baseURL: `${HOST_API_URL}/spsinfo`,
});

// Interceptor to add Authorization header to all requests
axiosWithToken.interceptors.request.use(
    async req => {
        try {
            const token = await getAccessToken();
            setAuthorizationHeader(req, token);
        } catch (e) {
            console.error('Failed to get valid Access Token for making API requests: ', e);
        }
        return req;
    },
    error => {
        console.error('Request error: ', error);
    }
);

// Function to get access token from session storage
async function getAccessToken() {
    let accessToken = sessionStorage.getItem(SPS_INFO_ACCESS_TOKEN);
    if (accessToken && isAccessTokenExpired(accessToken)) {
        // TODO Future enhancement: show a popup to user instead of VSP redirect
        console.info('Access token is expired.');
        window.location.href = VSP_LOGIN_URL; // VSP Login Page
    } else {
        return accessToken;
    }
}

// Function to set authorization header
function setAuthorizationHeader(req, token) {
    req.headers[AUTHORIZATION] = `${BEARER} ${token}`;
}

export {axiosWithToken as axios, axiosWithoutToken};